import { render } from "./Colors.vue?vue&type=template&id=5d30d56d"
import script from "./Colors.vue?vue&type=script&lang=ts"
export * from "./Colors.vue?vue&type=script&lang=ts"
script.render = render

export default script